// NOTE: Babel transform-export-extensions vietā izmantojam
// import * as ns + re-export esošo funkcionalitāti
import * as colorComponents from './components/colors';
import * as elevationComponents from './components/elevation';
export const colors = colorComponents;
export const elevation = elevationComponents;

export { default as ThemeProvider } from './ThemeProvider';
export {
  default as themed,
  getTheme,
  getThemeModes,
  isDefaultThemeMode,
} from './themed';

export * from './constants';
export { duration, ease } from './components/animation';

export {
  VisuallyHidden,
  accessibilityBorder,
  accessibilityHoverInvert,
  accessibilityHoverInvertDark,
} from './components/accessibility';



// WEBPACK FOOTER //
// ./src/core/theme/index.js